@if (props.label) {
  <apm-section-title
    [title]="props.label | apmTranslate"
    [ngClass]="{ 'mt-4': !isFirst }"
    [alignContentEnd]="false"
    matTooltip="{{ hasDatasheetMoreDetailsPermission ? field.key : '' }}"
  >
    @if (props.errorsResource?.length > 0) {
      <span class="ms-3"></span>
      <apm-icon
        class="me-2"
        size="sm"
        icon="i_alert_error"
        [isButton]="true"
        (iconClick)="showErrorMessages(props.errorsResource)"
      ></apm-icon>
    }
  </apm-section-title>
}
<div class="mb-2 overflow-x-auto">
  <table>
    <thead>
      <tr>
        <th class="text bold min-w-md bg-light-gray3"></th>
        @for (col of tableColumns; track col.field) {
          <th
            class="text-center bg-light-gray3 cursor-pointer formly-table-wrapper-value-cell"
            (click)="onColumnClick(col)"
            matTooltip="{{ col.tooltipResourceId ? (col.tooltipResourceId | apmTranslate) : '' }}"
          >
            <span class="text bold">{{ col.label }}</span>
          </th>
        }
      </tr>
    </thead>
    @for (row of field.fieldGroup; track row.key) {
      <tr
        [ngClass]="{
          'bg-certified-row--green': row.props?.flags === 1,
          'bg-certified-row--ligth-green': row.props?.flags === 3,
          'bg-certified-row--orange': row.props?.flags === 4,
        }"
      >
        <td class="text bold min-w-md formly-table-wrapper-value-cell">
          <span matTooltip="{{ hasDatasheetMoreDetailsPermission ? row.key : '' }}">{{
            row.props?.label ? (row.props?.label | apmTranslate) : '-'
          }}</span>
        </td>
        @for (col of tableColumns; track col.field) {
          <td class="text-center">
            <apm-table-wrapper-cell
              [value]="row.props?.rowData[col.field]"
              [props]="row.props"
            ></apm-table-wrapper-cell>
          </td>
        }
      </tr>
    }
  </table>
  @if (field.fieldGroup?.length === 0) {
    <div class="fw-bold text-center mt-2">
      {{ 444721 | apmTranslate }}
    </div>
  }
</div>
